// extracted by mini-css-extract-plugin
module.exports = {"recaptchaText":"H5mn"};